import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";

const FAQ = [
    {
        q: "À qui s'adressent vraiment ces outils ?",
        a: "Aux agences web, aux freelances spécialisés et aux pros du marketing internet. Si vous gérez les actifs digitaux de plusieurs clients, Web Me Up est conçu pour vous.",
    },
    {
        q: "Suis-je engagé sur la durée ?",
        a: "Non. Chaque SaaS de la suite est sans engagement, résiliable à tout moment. On préfère que vous restiez parce que ça vous rapporte, pas parce que vous êtes coincé.",
    },
    {
        q: "Puis-je revendre les outils à mes clients ?",
        a: "Selon les outils, oui. Local SEO et SMS Avis sont parfaitement adaptés à un modèle d'agence : vous les revendez ou les intégrez dans vos prestations. Contactez-nous pour les conditions agence.",
    },
    {
        q: "Les outils sont-ils sécurisés ?",
        a: "Oui. PleskDash fonctionne par exemple uniquement en API lecture seule. Hébergement européen, conformité RGPD, chiffrement TLS partout. Sébastien est certifié RSE et tient à des standards stricts.",
    },
    {
        q: "Comment se passe le support ?",
        a: "Support en français, par e-mail et chat. Pas de centre d'appels offshore : ce sont les personnes qui codent les outils qui vous répondent. Direct, rapide, sans script.",
    },
    {
        q: "D'autres outils sont-ils prévus ?",
        a: "Oui, plusieurs SaaS internes de Karedess sont en cours d'ouverture : facturation pour agences, audit express, automatisations. Inscrivez-vous à la newsletter pour être prévenu en priorité.",
    },
];

export default function FAQSection() {
    return (
        <section id="faq" className="relative py-24 sm:py-32">
            <div className="mx-auto max-w-4xl px-4 sm:px-6">
                <div className="text-center">
                    <Badge variant="outline" className="rounded-full border-border bg-card/60 px-3 py-1 text-xs text-muted-foreground">
                        FAQ
                    </Badge>
                    <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
                        Les questions <span className="text-gradient">qu'on nous pose</span> tous les jours.
                    </h2>
                </div>

                <div className="mt-12 overflow-hidden rounded-2xl border border-border bg-gradient-card">
                    <Accordion type="single" collapsible className="divide-y divide-border">
                        {FAQ.map((item, i) => (
                            <AccordionItem key={i} value={`q-${i}`} className="border-0 px-6">
                                <AccordionTrigger className="py-5 text-left font-display text-base font-semibold text-foreground hover:no-underline sm:text-lg">
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 text-sm leading-relaxed text-muted-foreground sm:text-base">
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
